import { t } from "@/i18n-js/instance";
import { paywallTypes } from "@circle-react/types";
import type { PaywallsFilterProps } from "./PaywallsFilter";
import { PaywallsFilter } from "./PaywallsFilter";

const localeRoot = "settings.paywalls_admin_dashboard.filters.paywalls";
const queryParamsKey = "paywalls";

interface SpacePaywallsFilterProps
  extends Omit<
    PaywallsFilterProps,
    "localeRoot" | "queryParamsKey" | "filterName" | "filterParams"
  > {}

export const SpacePaywallsFilter = (props: SpacePaywallsFilterProps) => (
  <PaywallsFilter
    {...props}
    localeRoot={localeRoot}
    queryParamsKey={queryParamsKey}
    filterName="paywalls-filter"
    filterParams={{ type: [paywallTypes.space] }}
  />
);

export const filterProperties = {
  name: "paywalls",
  filterKeys: ["paywalls"],
  component: SpacePaywallsFilter,
  label: t([localeRoot, "chip"]),
};
